/**
 * Created by jonas on 2024-09-30.
 */

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DeadwoodRipLayers, Layers} from "./view/DeadwoodRipLayers";

export class SkinLogo extends PIXI.Container {
    private logo:PIXI.Sprite;

    constructor() {
        super();
        this.init();
        DeadwoodRipLayers.getLayer(Layers.FOREGROUND)?.addChild(this);

    }

    private init() {
        this.logo = new PIXI.Sprite(ImgLoader.getImgTexture("skinLogo"));
        this.addChild(this.logo);
        this.onResize();
    }

    public onResize() {

        const spaceTop = Math.abs(NolimitApplication.screenBounds.top);
        const spaceLeft = Math.abs(NolimitApplication.screenBounds.left);

        if (NolimitApplication.isLandscape){
            this.logo.scale.set(1,1);
            const newScale = Math.min(spaceLeft / this.logo.width, 1);
            this.logo.scale.set(newScale,newScale);

            this.logo.position.set(NolimitApplication.screenBounds.left,NolimitApplication.screenBounds.top +50);
        } else {
            this.logo.scale.set(1,1);
            const newScale = Math.min(spaceTop / this.logo.height, 1);
            this.logo.scale.set(newScale,newScale);

            this.logo.position.set(360-(this.logo.width*0.5),NolimitApplication.screenBounds.top);
        }
    }


}